import { render } from "./TheInstallment.vue?vue&type=template&id=38019ffe&scoped=true"
import script from "./TheInstallment.vue?vue&type=script&lang=js"
export * from "./TheInstallment.vue?vue&type=script&lang=js"

import "./TheInstallment.vue?vue&type=style&index=0&id=38019ffe&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38019ffe"]])

export default __exports__